var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeature3Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 429,
    viewBox: "0 0 540 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.629 57.9309H206.321V169.335H281.629V57.9309Z",
    fill: "#3EC1F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.258 57.9309H206.321V169.335H156.858V85.3312C156.858 78.0642 159.745 71.0948 164.883 65.9563C170.022 60.8177 176.991 57.9309 184.258 57.9309Z",
    fill: "#3EC1F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.253 147.501C186.29 147.501 191.185 142.151 191.185 135.553C191.185 128.954 186.29 123.605 180.253 123.605C174.215 123.605 169.321 128.954 169.321 135.553C169.321 142.151 174.215 147.501 180.253 147.501Z",
    fill: "#F4E6D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.627 135.811H164.878C164.877 138.864 165.786 141.849 167.489 144.384C169.192 146.919 171.612 148.889 174.439 150.043V153.932H186.066V150.043C188.894 148.889 191.314 146.919 193.017 144.384C194.72 141.849 195.629 138.864 195.627 135.811Z",
    fill: "#3546AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.289 105.965L205.383 86.0361",
    stroke: "#3546AB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.432 57.9309V169.335",
    stroke: "#3546AB",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M482.157 350.254V307.479L456.312 281.187H383.677L357.832 307.479V347.138H267.373V330.646C238.407 327.525 247.317 306.137 231.276 306.137H202.758C200.68 306.13 198.643 306.72 196.891 307.839L156.629 282.956H115.191L63.2778 315.038H63.3896V355.431L28.5231 376.979V413.964H508.001V376.536L482.157 350.254Z",
    fill: "#F5EBDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M525.384 413.974H497.308C497.308 406.226 503.593 398.381 511.346 398.381C519.099 398.381 525.384 406.226 525.384 413.974Z",
    fill: "#FFB494"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M540 413.974H519.142C519.142 408.219 523.814 402.391 529.569 402.391C535.324 402.391 540 408.219 540 413.974Z",
    fill: "#FFB494"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.269 226.834C143.879 222.62 161.378 216.563 214.628 260.111C267.878 303.659 288.026 275.179 282.577 268.598C278.203 263.3 253.772 277.595 271.956 296.868C289.237 315.193 339.881 297.665 353.768 286.447C373.532 270.484 401.827 257.928 426.768 257.024",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12 12"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.109 315.048L115.191 282.966",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8757 315.047H167.221V413.488",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0529 413.673L62.539 355.917",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0092 376.989H61.9411",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6119 370.081H166.438",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M356.714 384.79H430.243",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M167.109 315.047H191.335",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M358.318 307.474H430.467V413.488",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M430.467 413.002V307.474H481.184",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M239.297 331.535H266.887",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M456.312 413.488V376.546H507.238",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M456.03 281.469L430.467 307.474",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M430.467 350.254L456.312 376.546",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M481.408 349.141H430.69",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M203.303 307.027C187.262 307.027 196.172 328.415 167.206 331.535H239.409C210.429 328.419 219.343 307.027 203.303 307.027Z",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M167.206 413.002V331.54H239.394V413.488",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M239.297 413.002V355.154H356.719V413.488",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M239.506 354.065L266.629 346.239",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M356.719 347.62V355.154H239.297",
    stroke: "#FFB494",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M262.624 368.526H262.74C264.849 368.526 266.872 369.364 268.363 370.855C269.855 372.346 270.693 374.369 270.693 376.478V413.979H254.652V376.478C254.652 375.432 254.858 374.397 255.259 373.43C255.66 372.464 256.248 371.587 256.988 370.848C257.729 370.109 258.608 369.524 259.575 369.126C260.542 368.727 261.578 368.523 262.624 368.526Z",
    fill: "#FFB494"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M334.369 368.526H334.505C336.614 368.526 338.637 369.364 340.128 370.855C341.62 372.346 342.457 374.369 342.457 376.478V413.979H326.417V376.478C326.417 374.369 327.255 372.346 328.746 370.855C330.237 369.364 332.26 368.526 334.369 368.526Z",
    fill: "#FFB494"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M298.496 368.526H298.632C300.742 368.526 302.764 369.364 304.256 370.855C305.747 372.346 306.585 374.369 306.585 376.478V413.979H290.544V376.478C290.544 374.369 291.382 372.346 292.873 370.855C294.365 369.364 296.387 368.526 298.496 368.526Z",
    fill: "#FFB494"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M482.983 386.793H483.119C485.228 386.793 487.251 387.631 488.742 389.122C490.233 390.613 491.071 392.636 491.071 394.745V413.974H475.031V394.745C475.031 392.636 475.868 390.613 477.36 389.122C478.851 387.631 480.874 386.793 482.983 386.793Z",
    fill: "#FFB494"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7139 386.793H84.8354C86.9445 386.793 88.9672 387.631 90.4585 389.122C91.9498 390.613 92.7877 392.636 92.7877 394.745V413.974H76.747V394.745C76.747 393.701 76.9527 392.667 77.3524 391.702C77.752 390.737 78.3378 389.86 79.0762 389.122C79.8146 388.383 80.6913 387.798 81.6561 387.398C82.6209 386.998 83.655 386.793 84.6993 386.793H84.7139Z",
    fill: "#FFB494"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.761 386.793H145.897C146.942 386.791 147.977 386.996 148.943 387.395C149.909 387.794 150.787 388.38 151.526 389.118C152.266 389.857 152.852 390.734 153.252 391.7C153.653 392.665 153.859 393.7 153.859 394.745V413.974H137.818V394.745C137.818 392.638 138.655 390.616 140.144 389.125C141.633 387.634 143.653 386.795 145.761 386.793Z",
    fill: "#FFB494"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M115.235 386.793H115.371C117.48 386.793 119.503 387.631 120.994 389.122C122.485 390.613 123.323 392.636 123.323 394.745V413.974H107.283V394.745C107.283 392.636 108.12 390.613 109.612 389.122C111.103 387.631 113.126 386.793 115.235 386.793Z",
    fill: "#FFB494"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7974 329.309H76.7568V356.49H92.7974V329.309Z",
    fill: "#FFB494"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M153.849 329.309H137.808V356.49H153.849V329.309Z",
    fill: "#FFB494"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M123.323 329.309H107.283V356.49H123.323V329.309Z",
    fill: "#FFB494"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M197.28 345.35H183.952V365.4H197.28V345.35Z",
    fill: "#FFB494"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 345.35H209.315V365.4H222.644V345.35Z",
    fill: "#FFB494"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M197.28 380.556H183.952V400.607H197.28V380.556Z",
    fill: "#FFB494"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 380.556H209.315V400.607H222.644V380.556Z",
    fill: "#FFB494"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M387.561 318.615H374.232V338.666H387.561V318.615Z",
    fill: "#FFB494"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M412.924 318.615H399.596V338.666H412.924V318.615Z",
    fill: "#FFB494"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M464.172 318.615H450.843V338.666H464.172V318.615Z",
    fill: "#FFB494"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M387.561 353.817H374.232V373.868H387.561V353.817Z",
    fill: "#FFB494"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M412.924 353.817H399.596V373.868H412.924V353.817Z",
    fill: "#FFB494"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.797 201.64C132.797 211.668 122.103 223.251 117.864 223.251C113.626 223.251 102.937 211.668 102.937 201.64C103.008 197.727 104.612 193.998 107.404 191.256C110.196 188.514 113.953 186.977 117.867 186.977C121.781 186.977 125.538 188.514 128.33 191.256C131.122 193.998 132.726 197.727 132.797 201.64Z",
    fill: "#FFB494"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M117.864 206.321C120.45 206.321 122.545 204.225 122.545 201.64C122.545 199.055 120.45 196.959 117.864 196.959C115.279 196.959 113.184 199.055 113.184 201.64C113.184 204.225 115.279 206.321 117.864 206.321Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M458.985 234.572C458.985 244.6 448.291 256.183 444.058 256.183C439.824 256.183 429.13 244.6 429.13 234.572C429.13 230.613 430.703 226.816 433.502 224.017C436.302 221.217 440.099 219.645 444.058 219.645C448.017 219.645 451.814 221.217 454.613 224.017C457.412 226.816 458.985 230.613 458.985 234.572Z",
    fill: "#FFB494"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M444.058 239.253C446.643 239.253 448.739 237.157 448.739 234.572C448.739 231.987 446.643 229.891 444.058 229.891C441.472 229.891 439.377 231.987 439.377 234.572C439.377 237.157 441.472 239.253 444.058 239.253Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6164 413.974H42.6923C42.6923 406.226 36.4073 398.381 28.6544 398.381C20.9014 398.381 14.6164 406.226 14.6164 413.974Z",
    fill: "#FFB494"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 413.974H20.8577C20.8577 408.219 16.1864 402.391 10.4313 402.391C4.67608 402.391 0 408.219 0 413.974Z",
    fill: "#FFB494"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M254.375 138.046C219.781 159.196 207.75 218.108 200.42 239.603C192.492 262.847 175.032 262.317 154.772 269.084C134.513 275.85 135.266 290.602 135.266 290.602C130.531 293.828 126.006 297.353 121.719 301.155L147.369 333.936C153.421 329.761 162.404 324.526 174.726 317.084C200.177 301.709 222.96 287.273 237.664 271.232C252.367 255.191 291.011 184.856 291.011 184.856L254.375 138.046Z",
    fill: "#4856DF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M147.37 333.936L121.714 301.16C110.243 311.368 103.37 321.089 99.9136 326.747L136.083 372.954C141.177 363.719 137.128 350.721 137.541 345.048C137.818 341.631 140.919 338.389 147.37 333.936Z",
    fill: "#30242A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M97.104 331.841L132.666 377.275C134.035 376.038 135.185 374.579 136.068 372.959L99.9039 326.752C98.8795 328.397 97.9448 330.096 97.104 331.841Z",
    fill: "#3EC1F3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M134.216 335.881L141.104 339.716",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M131.149 342.812L138.051 344.377",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M143.466 303.663L131.178 313.268",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M137.244 295.706L124.956 305.311",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M149.688 311.621L137.4 321.226",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M155.91 319.578L143.622 329.183",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M134.153 291.025L161.116 325.518",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M265.083 229.663C259.226 220.427 253.495 210.22 249.14 199.686",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M274.722 8.4675C277.06 8.4675 278.956 6.57199 278.956 4.23375C278.956 1.89552 277.06 0 274.722 0C272.384 0 270.488 1.89552 270.488 4.23375C270.488 6.57199 272.384 8.4675 274.722 8.4675Z",
    fill: "#3546AB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M288.162 65.9512L287.871 61.0321C293.534 61.7417 297.728 60.9008 300.727 59.3648L287.871 49.0162C287.871 49.0162 292.323 47.2371 289.65 37.8752L303.96 32.6742C303.206 30.7299 302.706 26.0441 301.262 21.0083L292.741 24.7171C290.752 28.5345 287.899 31.8351 284.41 34.356C282.968 32.8652 281.358 31.5472 279.612 30.4285C279.379 30.2778 279.126 30.1369 278.893 29.9959H278.868C278.63 29.8598 278.382 29.7286 278.144 29.6022H278.105C277.862 29.4807 277.619 29.3591 277.371 29.2522L277.323 29.1647C277.085 29.0529 276.837 28.9557 276.589 28.8585H276.521C276.273 28.771 276.035 28.6884 275.782 28.6106H275.699C275.456 28.5377 275.213 28.4745 274.96 28.421H274.873C274.625 28.3675 274.387 28.3287 274.134 28.2995H274.037C273.794 28.2752 273.551 28.2606 273.303 28.2557C271.179 28.2266 269.074 29.0918 267.319 31.5465C266.272 32.9697 265.703 34.6888 265.696 36.4559C265.73 41.6812 270.591 46.6636 274.931 48.1218C271.5 55.3595 260.412 59.8752 256.159 61.3772C256.295 63.0347 256.426 64.5756 256.543 65.9512H288.162Z",
    fill: "#EAA58B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M374.655 95.8062C372.643 95.8062 371.671 94.173 372.483 92.1606L379.288 75.3569L379.234 75.3083L379.351 75.1965C381.232 73.4291 382.983 71.5284 384.591 69.5093C387.663 65.5964 388.586 62.7528 387.507 61.5911C387.198 61.2791 386.788 61.0863 386.35 61.0467C385.905 60.9929 385.454 61.0192 385.018 61.1245C381.548 61.8827 375.603 66.6123 368.978 74.4139C360.962 83.8389 345.374 102.49 345.374 102.49C343.75 101.25 341.393 99.1504 338.569 96.618L316.141 125.452C320.947 129.193 326.078 132.497 331.472 135.324C332.49 132.174 334.432 129.403 337.046 127.372C339.661 125.341 342.826 124.145 346.13 123.937C349.434 123.73 352.724 124.522 355.571 126.211C358.419 127.899 360.692 130.406 362.095 133.404C375.608 123.309 386.282 105.294 391.284 95.8062H374.655Z",
    fill: "#EAA58B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M300.348 72.1877H293.495C306.565 80.0622 300.786 94.9168 300.786 94.9168C300.786 94.9168 318.64 107.394 306.585 122.546C307.47 121.615 308.219 120.564 308.811 119.425C308.811 119.425 311.689 122.069 316.102 125.452L338.53 96.6181C328.113 87.3242 311.203 72.1877 300.348 72.1877Z",
    fill: "#FFB494"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M231.724 96.2436C231.724 96.2436 218.6 107.185 227.47 121.836L232.142 95.5874L231.724 96.2436Z",
    fill: "#FF7235"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M256.523 65.9512V66.1116L257.087 65.9512H256.523Z",
    fill: "#FF7235"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M274.892 48.122C270.571 46.6637 265.71 41.696 265.657 36.4561L254.521 41.3168C254.953 47.4512 255.58 55.1847 256.101 61.3773C260.393 59.8753 271.49 55.3597 274.892 48.122Z",
    fill: "#30242A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M287.871 49.0161L300.727 59.3647C303.274 58.1375 305.292 56.0315 306.41 53.4346C308.305 48.6904 307.081 44.6074 305.603 39.3091C305.603 39.3091 309.37 36.7864 308.782 34.4483C308.296 32.5478 304.004 32.8102 304.004 32.8102L303.96 32.6887L289.65 37.8898C292.323 47.2371 287.871 49.0161 287.871 49.0161Z",
    fill: "#30242A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M284.41 34.3465C287.899 31.8255 290.752 28.525 292.741 24.7075L279.617 30.419C281.361 31.5379 282.97 32.856 284.41 34.3465Z",
    fill: "#30242A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M277.371 29.2085L277.323 29.1648L277.371 29.2085Z",
    fill: "#3546AB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M267.31 31.498C269.064 29.0433 271.169 28.1781 273.293 28.2073H273.245C272.024 14.7186 275.033 7.38365 277.264 3.90332C275.125 4.21925 273.013 4.69698 270.945 5.33239C255.483 10.0133 253.709 25.2616 254.142 34.3319C254.224 36.1498 254.38 38.5705 254.569 41.3023L265.705 36.4415C265.7 34.6649 266.262 32.933 267.31 31.498Z",
    fill: "#3546AB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M278.868 29.9716C278.63 29.8355 278.382 29.7043 278.144 29.5779C278.392 29.7043 278.63 29.8355 278.868 29.9716Z",
    fill: "#3EC1F3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M279.612 30.4187C279.379 30.268 279.126 30.127 278.893 29.9861C279.136 30.1368 279.379 30.268 279.612 30.4187Z",
    fill: "#3EC1F3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M275.69 28.5863C275.447 28.5134 275.203 28.4502 274.951 28.3967C275.199 28.4502 275.447 28.5134 275.69 28.5863Z",
    fill: "#3EC1F3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M278.105 29.5585C277.862 29.437 277.619 29.3154 277.371 29.2085C277.619 29.3154 277.862 29.437 278.105 29.5585Z",
    fill: "#3EC1F3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M274.027 28.2509C273.784 28.2266 273.541 28.212 273.293 28.2071C273.536 28.1925 273.784 28.2266 274.027 28.2509Z",
    fill: "#3EC1F3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M274.863 28.382C274.615 28.3285 274.377 28.2897 274.124 28.2605C274.372 28.2897 274.615 28.3285 274.863 28.382Z",
    fill: "#3EC1F3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M276.511 28.8536C276.263 28.7661 276.025 28.6835 275.772 28.6057C276.02 28.6786 276.263 28.7661 276.511 28.8536Z",
    fill: "#3EC1F3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M277.323 29.1649C277.085 29.0531 276.837 28.9559 276.589 28.8586C276.837 28.9753 277.075 29.0725 277.323 29.1649Z",
    fill: "#3EC1F3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M273.245 28.1927H273.293C273.536 28.1927 273.779 28.1927 274.027 28.2364H274.124C274.372 28.2656 274.61 28.3045 274.863 28.358H274.951C275.199 28.4114 275.437 28.4746 275.69 28.5475H275.772C276.02 28.6253 276.258 28.7079 276.511 28.7954H276.579C276.827 28.8926 277.065 28.9899 277.313 29.1017L277.371 29.126C277.619 29.2329 277.857 29.3544 278.105 29.4759H278.144C278.392 29.6023 278.63 29.7336 278.869 29.8697H278.893C279.136 30.0106 279.379 30.1516 279.612 30.3023L292.736 24.5908L301.257 20.8821C298.657 11.8118 292.994 1.56528 277.26 3.80124C275.033 7.37878 272.025 14.7137 273.245 28.1927Z",
    fill: "#3EC1F3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M347.133 123.882C343.643 123.883 340.243 124.991 337.423 127.048C334.602 129.104 332.507 132.002 331.438 135.324C338.593 138.96 346.161 141.196 352.038 139.033C355.638 137.648 359.02 135.752 362.08 133.404C360.755 130.558 358.643 128.15 355.996 126.463C353.348 124.777 350.273 123.881 347.133 123.882Z",
    fill: "#CA7358"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M302.599 151.287C318.639 140.812 307.46 122.978 306.585 122.545C318.615 107.394 300.791 94.9166 300.791 94.9166C300.791 94.9166 306.565 80.0621 293.499 72.1876H288.532L288.162 65.9512H257.102L256.538 66.1116L257.063 72.1876H247.04L232.142 95.5923L227.47 121.841L227.709 122.234C227.55 122.529 227.388 122.826 227.223 123.124C224.209 129.054 223.767 134.099 224.539 138.192C226.148 146.752 233.041 151.263 233.041 151.263H302.599V151.287Z",
    fill: "#FF7235"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M233.06 159.099H302.575V152.848V151.287H233.06V152.848V159.099Z",
    fill: "#30242A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M225.798 94.9167H300.791",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M227.587 122.545H306.974",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M289.65 75.3084L289.484 72.6738",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M281.182 73.9716L280.74 66.8408",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M274.499 73.9716L274.056 66.8408",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M267.815 73.9716L267.373 66.8408",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M344.441 102.115L339.113 108.731",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M281.629 60.6042C283.6 61.2935 285.641 61.7613 287.715 61.9993",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M384.591 69.5094C384.615 70.8169 385.563 71.7405 387.055 71.7405H401.594C403.606 71.7405 405.9 70.1072 406.717 68.09L411.15 57.1143C411.962 55.102 410.99 53.4688 408.977 53.4688H394.434C392.421 53.4688 390.127 55.102 389.315 57.1143L387.507 61.5911C388.586 62.7577 387.663 65.6207 384.591 69.5094Z",
    fill: "#F5EBDD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M414.528 46.3428H410.601L410.256 47.1934C409.983 47.8266 409.542 48.373 408.981 48.7732C408.42 49.1734 407.759 49.4121 407.072 49.4634H399.577C398.327 49.4634 397.72 48.4475 398.225 47.1934L398.57 46.3428H394.643C392.626 46.3428 390.336 47.976 389.52 49.9932L385.019 61.1293C385.454 61.024 385.905 60.9977 386.35 61.0515C386.788 61.0912 387.198 61.2839 387.507 61.5959L389.315 57.1192C390.127 55.1068 392.422 53.4736 394.434 53.4736H408.977C410.99 53.4736 411.962 55.1068 411.15 57.1192L406.717 68.0948C405.9 70.112 403.606 71.7453 401.594 71.7453H387.055C385.543 71.7453 384.625 70.8217 384.591 69.5142C382.978 71.5321 381.222 73.4311 379.336 75.1964L379.273 75.3568L372.468 92.1606C371.656 94.173 372.628 95.8062 374.641 95.8062H394.531C396.543 95.8062 398.838 94.173 399.65 92.1606L416.662 49.9932C417.518 47.976 416.546 46.3428 414.528 46.3428ZM395.085 89.1177C394.82 89.7333 394.391 90.2645 393.846 90.6538C393.304 91.0744 392.645 91.3157 391.96 91.344H380.858C379.623 91.344 379.03 90.3475 379.526 89.1177C379.796 88.4969 380.23 87.9614 380.781 87.5691C381.333 87.1768 381.981 86.9425 382.656 86.8915H393.797C395.003 86.8964 395.596 87.8928 395.1 89.1226L395.085 89.1177Z",
    fill: "#3546AB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M393.773 86.8965H382.632C381.957 86.9475 381.309 87.1818 380.757 87.5741C380.205 87.9664 379.771 88.5019 379.502 89.1227C379.015 90.3525 379.599 91.349 380.833 91.349H391.974C392.659 91.3207 393.319 91.0794 393.86 90.6587C394.406 90.2695 394.835 89.7383 395.1 89.1227C395.596 87.893 395.003 86.8965 393.773 86.8965Z",
    fill: "#3EC1F3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M399.577 49.4634H407.072C407.759 49.4121 408.42 49.1734 408.981 48.7732C409.542 48.373 409.983 47.8266 410.256 47.1934L410.601 46.3428H398.57L398.225 47.1934C397.72 48.4475 398.327 49.4634 399.577 49.4634Z",
    fill: "#3EC1F3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M312.379 16.9351L282.524 30.3022",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M302.788 44.8166C301.894 45.0548 298.968 44.5638 298.487 42.0508",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M298.185 32.1054C298.98 32.1054 299.624 31.4612 299.624 30.6666C299.624 29.8719 298.98 29.2278 298.185 29.2278C297.391 29.2278 296.746 29.8719 296.746 30.6666C296.746 31.4612 297.391 32.1054 298.185 32.1054Z",
    fill: "#30242A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M273.488 37.1948L278.713 40.5196",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M284.75 33.4229L290.544 37.8753",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M273.609 48.574L289.207 49.0163",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M334.194 152.848C335.967 152.848 337.667 153.552 338.92 154.805C340.173 156.059 340.878 157.759 340.878 159.531V159.531C340.88 160.411 340.709 161.282 340.375 162.096C340.04 162.909 339.548 163.648 338.927 164.272C338.306 164.895 337.569 165.389 336.757 165.727C335.944 166.064 335.074 166.238 334.194 166.239",
    stroke: "#FF7235",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M343.57 152.848C345.34 152.853 347.035 153.559 348.284 154.812C349.533 156.065 350.235 157.762 350.235 159.531C350.24 161.304 349.541 163.007 348.291 164.265C347.041 165.523 345.344 166.233 343.57 166.239",
    stroke: "#FF7235",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M391.746 153.737H318.124C314.951 153.737 312.379 156.309 312.379 159.483V159.58C312.379 162.753 314.951 165.325 318.124 165.325H391.746C394.919 165.325 397.491 162.753 397.491 159.58V159.483C397.491 156.309 394.919 153.737 391.746 153.737Z",
    fill: "#30242A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M404.093 400.728L359.75 154.03L348.344 156.08L392.688 402.778L404.093 400.728Z",
    fill: "#30242A"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M318.221 153.737H318.124C314.951 153.737 312.379 156.309 312.379 159.483V159.58C312.379 162.753 314.951 165.325 318.124 165.325H318.221C321.395 165.325 323.967 162.753 323.967 159.58V159.483C323.967 156.309 321.395 153.737 318.221 153.737Z",
    stroke: "#FF7235",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M373.839 153.212C375.151 153.669 376.288 154.522 377.093 155.655C377.898 156.787 378.33 158.142 378.33 159.531V159.531C378.33 160.83 377.951 162.1 377.241 163.187C376.53 164.273 375.519 165.13 374.33 165.651",
    stroke: "#FF7235",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M381.616 153.212C382.928 153.669 384.066 154.522 384.871 155.655C385.675 156.787 386.108 158.142 386.107 159.531V159.531C386.107 160.83 385.728 162.1 385.018 163.187C384.308 164.273 383.296 165.13 382.107 165.651",
    stroke: "#FF7235",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M398.381 402.391H235.734V413.979H398.381V402.391Z",
    fill: "#30242A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M245.757 428.236C253.633 428.236 260.018 421.851 260.018 413.974C260.018 406.098 253.633 399.713 245.757 399.713C237.88 399.713 231.495 406.098 231.495 413.974C231.495 421.851 237.88 428.236 245.757 428.236Z",
    fill: "#30242A"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M245.757 419.321C248.71 419.321 251.104 416.927 251.104 413.974C251.104 411.021 248.71 408.627 245.757 408.627C242.804 408.627 240.41 411.021 240.41 413.974C240.41 416.927 242.804 419.321 245.757 419.321Z",
    fill: "#FFB494"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M400.908 428.236C408.785 428.236 415.17 421.851 415.17 413.974C415.17 406.098 408.785 399.713 400.908 399.713C393.032 399.713 386.647 406.098 386.647 413.974C386.647 421.851 393.032 428.236 400.908 428.236Z",
    fill: "#30242A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M400.908 419.321C403.861 419.321 406.255 416.927 406.255 413.974C406.255 411.021 403.861 408.627 400.908 408.627C397.955 408.627 395.562 411.021 395.562 413.974C395.562 416.927 397.955 419.321 400.908 419.321Z",
    fill: "#FFB494"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M268.039 413.974H223.48C223.566 408.122 225.952 402.539 230.12 398.432C234.289 394.324 239.907 392.021 245.759 392.021C251.612 392.021 257.229 394.324 261.398 398.432C265.567 402.539 267.952 408.122 268.039 413.974Z",
    fill: "#FF7235"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M423.185 413.974H378.626C378.713 408.122 381.098 402.539 385.267 398.432C389.436 394.324 395.053 392.021 400.906 392.021C406.758 392.021 412.376 394.324 416.545 398.432C420.714 402.539 423.099 408.122 423.185 413.974Z",
    fill: "#FF7235"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M289.786 363.621H331.462C331.948 356.33 333.329 346.152 335.025 332.172C338.603 302.652 341.286 275.816 337.708 254.351C334.131 232.885 302.575 159.079 302.575 159.079H243.142C238.475 199.351 277.449 245.144 289.854 264.165C303.27 284.74 292.09 298.156 284.935 318.28C277.78 338.403 289.854 346.905 289.854 346.905C289.484 352.47 289.461 358.053 289.786 363.621Z",
    fill: "#4856DF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M296.523 397.044H355.202C351.056 387.323 338.34 382.515 334.131 378.685C331.54 376.332 330.937 371.744 331.462 363.616H289.786C290.695 379.171 294.161 390.754 296.523 397.044Z",
    fill: "#30242A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M298.798 402.391H356.495C356.37 400.548 355.933 398.74 355.202 397.044H296.523C297.184 398.866 297.944 400.651 298.798 402.391Z",
    fill: "#3EC1F3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M305.992 348.47V363.101",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M295.891 348.47V363.101",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M316.092 348.47V363.101",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M326.193 348.47V363.101",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M289.961 348.023H332.736",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M316.817 193.673C315.358 190.067 313.968 186.577 312.632 183.296L290.758 179.456V179.533C290.326 181.994 290.889 184.525 292.322 186.57C293.756 188.616 295.944 190.008 298.404 190.441L316.817 193.673Z",
    fill: "#3EC1F3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M324.856 375.652L331.764 372.823",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M328.424 382.34L334.194 377.684",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M400.165 90.8968C400.165 90.8968 407.816 91.1982 408.428 84.5146C408.428 84.5146 413.892 82.0016 412.463 77.0095C412.463 77.0095 417.459 75.5805 416.03 70.5836C415.938 70.2676 418.869 69.6989 418.723 65.5818C418.509 59.5739 414.436 55.2478 412.657 54.8006C407.31 53.4639 409.342 62.1501 409.089 61.9314C405.973 59.2579 401.424 58.0427 399.8 59.4037C396.971 61.7758 398.935 64.945 398.935 64.945C398.935 64.945 395.309 64.0895 393.535 66.7095C391.376 69.8885 395.236 72.8536 395.236 72.8536C395.236 72.8536 391.192 73.3056 391.867 77.0484C392.616 81.2336 398.901 82.1668 401.881 86.5513L400.165 90.8968Z",
    fill: "#EAA58B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M395.071 72.0854C399.329 73.6846 406.736 77.2282 408.841 83.0757",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M399.844 64.6484C403.49 66.6365 409.93 70.7196 412.832 76.047",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M409.779 61.2461C412.176 63.3751 414.776 66.209 416.366 69.5094",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M257.121 72.1877C257.121 72.1877 273.094 96.2438 268.709 119.425C265.589 135.913 228.156 150.199 206.321 155.059V142.149C206.321 142.149 251.774 131.013 257.121 110.957C260.363 98.8054 247.317 72.1877 247.317 72.1877",
    fill: "#F5EBDD"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M362.732 150.198C360.058 143.51 351.591 136.384 341.787 132.816C322.946 125.967 277.172 135.937 277.172 135.937L270.314 121.291L236.565 137.818C241.426 147.301 247.259 155.273 253.218 160.785C255.247 158.273 257.97 156.412 261.047 155.434C264.125 154.456 267.423 154.404 270.53 155.284C273.637 156.164 276.417 157.938 278.524 160.386C280.632 162.833 281.973 165.845 282.383 169.049C301.043 167.59 321.682 159.06 327.535 153.795C327.535 153.795 331.098 156.916 335.108 157.358C335.108 158.695 328.871 176.52 340.012 172.509C340.012 172.509 343.128 176.52 347.586 172.067C347.586 172.067 350.706 176.52 355.164 172.509C355.164 172.509 357.594 174.031 360.953 170.283C364.958 165.753 366.144 158.7 362.732 150.198Z",
    fill: "#EAA58B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M247.317 72.1877H246.214C237.168 72.1877 222.357 78.8762 224.141 96.2001C225.707 110.702 229.916 124.794 236.56 137.779L270.309 121.253L247.317 72.1877Z",
    fill: "#FFB494"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M266.036 154.626C263.578 154.625 261.151 155.173 258.933 156.232C256.715 157.291 254.762 158.834 253.218 160.746C254.453 161.899 255.751 162.981 257.107 163.988C263.382 168.577 272.603 169.753 282.383 168.99C281.869 165.018 279.926 161.37 276.918 158.726C273.909 156.083 270.041 154.625 266.036 154.626Z",
    fill: "#CA7358"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M340.401 171.761C342.346 167.872 346.759 157.791 343.571 151.064",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M265.589 137.249L276.093 135.096",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M348.29 171.586C350.312 167.483 354.687 157.592 351.591 151.064",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M356.068 172.072C358.012 168.154 362.333 157.752 359.169 151.064",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3Img);
export default __webpack_public_path__ + "static/media/feature3-img.553e26ae86a0e05e520f069984285585.svg";
export { ForwardRef as ReactComponent };